import { Color, InfoModal } from "@starrez/starryui";
import { Text } from "@starrez/starryui9";
import * as React from "react";
import { strings } from "../../../../localisation";
import { ISendEmailDataModel } from "../../../EmailWizard/models/SendEmail";
import { SendEmailExecuteModel } from "../../../EmailWizard/models/SendEmail/SendEmailExecuteModel";
import { IValidatedDynamicTextResult } from "../graphQL/validateDynamicText";
import { DynamicTextValidationErrorsContainer, DynamicTextValidationErrorsGroup, DynamicTextValidationErrorsList } from "./DynamicTextValidationErrors.styles";

export interface IDynamicTextValidationErrorsProps {
    Errors: IValidatedDynamicTextResult[];
    OnClose: () => void;
}

export const DynamicTextValidationErrors = ({ Errors, OnClose }: IDynamicTextValidationErrorsProps) => {

    const getFieldDisplayName = (fieldName: string): string => {
        // We need to use the formDataModel field names as keys so we can invalidate them. So we need
        // to format those names so we can display a friendly version for errors below

        let displayName = fieldName.replace(`${nameof.full<SendEmailExecuteModel<ISendEmailDataModel>>((m) => m.formDataModel)}.`, "")
            .replace("Email", "")
            .replace("Items", "")
            .replace("Address", "");

        // Return with spaces between capitals e.g. AddressItems -> Address Items
        return displayName.replace(/([A-Z][a-z])/g, ' $1').trim();
    };

    const getErrorDisplayText = (errorType: string): string => {
        switch (errorType) {
            case "SyntaxError":
                return "";
            default:
                return ` - ${strings.ScribanValidation_Error_MergeFieldNotRecognised}`;
        }
    };

    if (Errors?.length) {

        return (
            <InfoModal Header={strings.ScribanValidation_Error_Header} InfoType="Error" OnCloseRequest={OnClose}>
                <DynamicTextValidationErrorsContainer>
                    {Errors.filter((err) => err.errors.length).map((group) =>
                        <DynamicTextValidationErrorsGroup key={group.key}>
                            <Text variant={"normal.bold"}>
                                {getFieldDisplayName(group.key)}
                            </Text>
                            <DynamicTextValidationErrorsList>
                                {group.errors.map((errorMessage) =>
                                    <li key={errorMessage.message}>
                                        <Text variant={"normal.medium"} color={Color.Grey.G70}>
                                            {errorMessage.message}{" "}
                                        </Text>
                                        <Text variant={"normal.regular"} color={Color.Grey.G60}>
                                            {getErrorDisplayText(errorMessage.type)}
                                        </Text>
                                    </li>
                                )}
                            </DynamicTextValidationErrorsList>
                        </DynamicTextValidationErrorsGroup>
                    )}
                </DynamicTextValidationErrorsContainer>
            </InfoModal>
        );
    }

    return null;
};
